<template>
  <div>Work</div>
</template>

<script>
export default {};
</script>

<style></style>
